import { render, staticRenderFns } from "./PopupsContainer.vue?vue&type=template&id=040a82cb&scoped=true&"
import script from "./PopupsContainer.vue?vue&type=script&lang=ts&"
export * from "./PopupsContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040a82cb",
  null
  
)

export default component.exports